module.exports = __webpack_public_path__ + "static/media/Password.352bce62.svg";